import { ControlPointRounded } from '@mui/icons-material'
import { Button } from '@mui/material'
import React, { useContext, useRef } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { BannerStatic } from '../../../../../components'
import { useSelector } from 'react-redux'
import SectionFormDialog from '../section-form-dialog'
import { BuildNavigationContext } from '../..'

const useStyles = makeStyles(({ palette }) => ({
  addSectionButton: {
    border: '1px dashed #BCBCBC',
    borderRadius: '10px',
    color: palette.primary.main,
    marginTop: '16px',
    marginBottom: '16px'
  }
}))

const AddSectionDialog = ({ sessionId }) => {
  const classes = useStyles()
  const modalRef = useRef()
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const { discardChangesOnNavigationGuard } = useContext(BuildNavigationContext)

  const [addSection] = useEvent([
    SkillBiteEditSlice.eventBus.addSection({
      onSuccess: () => {
        BannerStatic.show({
          label: 'Section added successfully'
        })
        modalRef.current.close()
      },
      onError: (error) => {
        console.log(error)
        BannerStatic.show({
          label: 'Error trying to add section',
          isError: true
        })
        modalRef.current.close()
      }
    })
  ])

  const handleClickOpen = () => {
    discardChangesOnNavigationGuard(() => {
      modalRef.current.open()
    })
  }

  const handleOnSubmit = (data) => {
    addSection.trigger({
      name: data.name,
      order: selectedSession.sections.length + 1,
      skillBiteId: skillBite.id,
      sessionId
    })
  }

  return (
    <>
      <Button className={classes.addSectionButton} size='large' data-test='add-section-btn' fullWidth onClick={handleClickOpen}>
        <ControlPointRounded color='primary' sx={{ mr: 1 }} />
        Add Section
      </Button>
      <SectionFormDialog
        ref={modalRef}
        title='New Section'
        isLoading={addSection.isWorking}
        submitText='Add'
        onSubmit={handleOnSubmit}
        section={{}}
      />
    </>
  )
}

export default AddSectionDialog
